/** P4-Insights-Hooks: Progress (kanal-scoped), NBA-Karten, Regel-Abdeckung. */
import { useQuery } from '@tanstack/react-query'

import { getIssuesProgress, getNbaCards, getRuleCoverage } from '@/lib/api/issues-insights'

export function useIssuesProgress(channelId: string | null) {
  return useQuery({
    queryKey: ['issues-progress', channelId],
    queryFn: async () => (await getIssuesProgress(channelId)).progress,
  })
}

/**
 * Geteilter `['issues-nba']`-Cache-Eintrag (staleTime 5min, siehe
 * query-client.ts). Reiner Read — Invalidierung liegt bewusst NICHT hier,
 * sondern beim jeweiligen Konsumenten (z.B. `ApplyResultDialog` invalidiert
 * gezielt beim Öffnen-Übergang), sonst würde jeder Mount eines Consumers
 * (z.B. `NbaCardsRow`) den Cache für alle anderen Consumer verwerfen.
 */
export function useNbaCards(enabled = true) {
  return useQuery({
    queryKey: ['issues-nba'],
    queryFn: async () => (await getNbaCards()).cards,
    enabled,
  })
}

export function useRuleCoverage() {
  return useQuery({
    queryKey: ['issues-rule-coverage'],
    queryFn: async () => (await getRuleCoverage()).channels,
  })
}
